import AppService from './appService'
import type { ContextStore } from '@/stores/context'

export default class CloudsyncService extends AppService {
  constructor(appContext: ContextStore) {
    super(appContext)
  }

  async getConsent() {
    try {
      const response = await this.mboApiV1.get('cloudsync/consent', {
        params: {
          shopId: this.context.accountsShopId,
        },
      })
      return response.data
    } catch (err) {
      console.error(err)
      throw err
    }
  }

  async updateConsent() {
    try {
      return await this.mboApiV1.post('cloudsync/consent', {
        shopId: this.context.accountsShopId,
        accounts_token: this.context.accountsShopToken,
      })
    } catch (err) {
      console.error(err)
      throw err
    }
  }
} 